export interface Product {
  id: number;
  name: string;
  brand: string;
  category: 'cadeira' | 'mesa' | 'aco' | 'cabine' | 'divisoria' | 'persiana';
  price: number;
  description: string;
  features: string[];
  image: string;
  badge?: string;
}

export const products: Product[] = [
  // ─── FRISOKAR ───────────────────────────────────────────────────────────────
  {
    id: 1,
    name: 'Frisokar Goah',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 980,
    description: 'Cadeira operativa com design moderno e estrutura robusta. Encosto ergonômico com regulagem de altura a gás, braços ajustáveis e rodízios duplos para uso intensivo.',
    features: ['Encosto ergonômico', 'Braços ajustáveis', 'Regulagem de altura a gás', 'Rodízios duplos', 'Certificação NR17'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2018/05/3308-300x300.jpg',
    badge: 'Mais Vendido',
  },
  {
    id: 2,
    name: 'Frisokar Office Mona',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 1450,
    description: 'Cadeira office com estrutura toda em tela, encosto de cabeça, braços e assento regulável. Design moderno e funcional apresentado na Formóbile 2024.',
    features: ['Estrutura em tela', 'Encosto de cabeça', 'Braços reguláveis', 'Assento regulável', 'Design contemporâneo'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2024/06/5175.jpg',
    badge: 'Novo',
  },
  {
    id: 3,
    name: 'Frisokar Office Mona Alta',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 1580,
    description: 'Versão alta da Cadeira Office Mona com mecanismo ergonômico que permite ajustes personalizados, garantindo postura saudável e confortável para longas jornadas.',
    features: ['Mecanismo ergonômico', 'Encosto alto em tela', 'Apoio de cabeça', 'Braços 4D', 'Assento deslizante'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2024/06/Mona-Alta-EC_01.jpg',
  },
  {
    id: 4,
    name: 'Frisokar Cadeira Duo',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 890,
    description: 'Revolução sustentável da Frisokar. Feita de dois polímeros 100% recicláveis, combina design inteligente com práticas conscientes. Compacta e reciclável.',
    features: ['Polímeros 100% recicláveis', 'Design sustentável', 'Compacta e leve', 'Programa Destino Certo', 'Fácil montagem'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2024/07/5202.jpg',
    badge: 'Sustentável',
  },
  {
    id: 5,
    name: 'Frisokar Sky',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 1100,
    description: 'Linha que prioriza inovação e leveza, com duas alturas de encosto e múltiplas configurações de assento. Perfeita para ambientes de trabalho modernos e dinâmicos.',
    features: ['Design inovador e leve', 'Duas alturas de encosto', 'Múltiplas configurações', 'Regulagem de altura a gás', 'Rodízios duplos'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2018/06/sky_alta_02-300x300.jpg',
  },
  {
    id: 6,
    name: 'Frisokar Cadeira Acto',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 1250,
    description: 'Cadeira de escritório com design contemporâneo, encosto em tela mesh de alta ventilação e mecanismo sincronizado. Ideal para uso prolongado em ambientes corporativos.',
    features: ['Encosto em tela mesh', 'Mecanismo sincronizado', 'Apoio lombar ajustável', 'Braços reguláveis', 'Base em nylon reforçado'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2024/03/PoltronaTime_03-300x300.jpg',
  },
  {
    id: 7,
    name: 'Frisokar Poltrona Pix',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 1380,
    description: 'Poltrona para escritório com design colaborativo, estofamento em tecido de alta qualidade e estrutura em aço. Ideal para salas de espera e ambientes de convivência.',
    features: ['Design colaborativo', 'Estofamento premium', 'Estrutura em aço', 'Diversas cores', 'Fácil limpeza'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2018/06/Pix_02-e1529499920931-300x300.png',
  },
  {
    id: 8,
    name: 'Frisokar Time',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 1680,
    description: 'Redefine o conforto com modelos fixos e giratórios, incluindo apoio de cabeça, porta-paletó e variadas opções de revestimento. Elegância e funcionalidade em um só produto.',
    features: ['Modelos fixo e giratório', 'Apoio de cabeça', 'Porta-paletó', 'Variadas opções de revestimento', 'Mecanismo relax'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2024/03/PoltronaTime_03-300x300.jpg',
    badge: 'Premium',
  },
  {
    id: 9,
    name: 'Frisokar Cadeira Up!',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 420,
    description: 'Cadeira plástica multiuso com design premiado Good Design Award. Disponível em versão fixa, giratória e longarina. Leve, empilhável e disponível em diversas cores.',
    features: ['Good Design Award', 'Versão fixa e giratória', 'Empilhável', 'Diversas cores', 'Leve e resistente'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2018/05/3308-300x300.jpg',
  },
  {
    id: 10,
    name: 'Frisokar Poltrona Pipeline',
    brand: 'Frisokar',
    category: 'cadeira',
    price: 2100,
    description: 'Poltrona premium da linha Frisokar Premium com design sofisticado, estofamento de alta qualidade e estrutura metálica. Perfeita para salas executivas e lounges.',
    features: ['Linha Frisokar Premium', 'Estofamento de alta qualidade', 'Estrutura metálica', 'Design sofisticado', 'Garantia de 5 anos'],
    image: 'https://www.frisokar.com.br/wp-content/uploads/2024/07/5534-300x300.jpg',
    badge: 'Premium',
  },

  // ─── PLAXMETAL ──────────────────────────────────────────────────────────────
  {
    id: 11,
    name: 'Plaxmetal Brizza',
    brand: 'Plaxmetal',
    category: 'cadeira',
    price: 1899.99,
    description: 'Uma das linhas mais populares da Plaxmetal, com encosto em tela mesh que favorece a ventilação e ergonomia avançada. Ideal para longas jornadas de trabalho.',
    features: ['Encosto em tela mesh', 'Ergonomia avançada', 'Mecanismo Back System', 'Braços reguláveis', 'Garantia de 5 anos'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/ab532543-c89b-4ae8-b0c2-e02a6f122f90-3808c7b1d21b7f528e17571994253961-1024-1024.webp',
    badge: 'Mais Vendido',
  },
  {
    id: 12,
    name: 'Plaxmetal TH2 Fixa',
    brand: 'Plaxmetal',
    category: 'cadeira',
    price: 449.99,
    description: 'Cadeira fixa empilhável com estrutura em aço e assento/encosto em polipropileno. Ideal para auditórios, salas de treinamento e eventos corporativos.',
    features: ['Estrutura em aço', 'Assento e encosto em polipropileno', 'Versão fixa empilhável', 'Leve e durável', 'Fácil armazenamento'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/65b67bb5-d7bf-4287-b663-f3f7b002bb69-98fbeacfaba1ca957817651487702237-1024-1024.webp',
  },
  {
    id: 13,
    name: 'Plaxmetal Fluidy Fixa',
    brand: 'Plaxmetal',
    category: 'cadeira',
    price: 839.99,
    description: 'Cadeira diretor fixa com design ergonômico, encosto anatômico e acabamento premium. Ideal para salas de reunião e escritórios executivos.',
    features: ['Design ergonômico', 'Encosto anatômico', 'Acabamento premium', 'Estrutura reforçada', 'Ideal para reuniões'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/9b4c945c-9855-4b61-94c9-4c5630261013-d70a722cdec9e3fbff17615897403940-1024-1024.webp',
  },
  {
    id: 14,
    name: 'Plaxmetal Beezi',
    brand: 'Plaxmetal',
    category: 'cadeira',
    price: 899.99,
    description: 'Design contemporâneo com opções de cores variadas, ideal para ambientes colaborativos e dinâmicos. Combina estética moderna com conforto ergonômico.',
    features: ['Design contemporâneo', 'Diversas opções de cores', 'Mecanismo Relaxplax', 'Espuma de alta densidade', 'Ideal para coworking'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/32df56a1-4de2-4f1b-b7f8-9a7f5a07e47e-1-5cf9c69961cd306eba17615905713181-1024-1024.webp',
  },
  {
    id: 15,
    name: 'Plaxmetal Bix X+',
    brand: 'Plaxmetal',
    category: 'cadeira',
    price: 1899.99,
    description: 'Cadeira executiva premium com encosto em tela mesh de alta resistência, mecanismo sincronizado e braços 4D. Conforto e tecnologia para executivos exigentes.',
    features: ['Encosto em tela mesh premium', 'Mecanismo sincronizado', 'Braços 4D', 'Base em alumínio polido', 'Garantia de 5 anos'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/095d47be-5dcc-4a30-a2e3-9571b86d95f5-ca1a496b6e89d0574a17572006209747-1024-1024.webp',
    badge: 'Premium',
  },
  {
    id: 16,
    name: 'Plaxmetal Plus Size',
    brand: 'Plaxmetal',
    category: 'cadeira',
    price: 3499.99,
    description: 'Cadeira operativa reforçada com capacidade de até 185kg. Estrutura extra-resistente, assento amplo e mecanismo robusto para máximo conforto e durabilidade.',
    features: ['Capacidade até 185kg', 'Estrutura extra-resistente', 'Assento amplo', 'Mecanismo robusto', 'Garantia reforçada'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/b880f18d-66b0-455d-abfe-dff3717f1ded-9b951fe63d26fffda517572002266260-1024-1024.webp',
    badge: 'Plus Size',
  },

  // ─── MARZO VITORINO ─────────────────────────────────────────────────────────
  {
    id: 17,
    name: 'Marzo Vitorino Altis',
    brand: 'Marzo Vitorino',
    category: 'mesa',
    price: 3800,
    description: 'Linha executiva e de diretoria com tampos de até 55mm de espessura, pés angulados metálicos e detalhes em courvin para maior conforto. Sofisticação para altos executivos.',
    features: ['Tampo até 55mm de espessura', 'Pés angulados metálicos', 'Detalhes em courvin', 'Passagem para cabos', 'Acabamento premium'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/78bc357c-0c62-47b3-9e50-94be68ecdbf1-cce93b10411622d5f417367963514538-1024-1024.webp',
    badge: 'Premium',
  },
  {
    id: 18,
    name: 'Marzo Vitorino Attuale',
    brand: 'Marzo Vitorino',
    category: 'mesa',
    price: 1850,
    description: 'Uma das linhas mais versáteis, com tampos em BP de 25mm e pés metálicos com calhas para subida de fiação. Inclui modelos de mesas auxiliares e diretivas.',
    features: ['Tampo em BP 25mm', 'Pés metálicos com calha de fiação', 'Modelos auxiliares e diretivos', 'Passagem para cabos', 'Fácil montagem'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/9058db64-619b-4f67-8bb2-2bd60e929dd8-01b5fc77f51d1d6ddc17439527041470-1024-1024.webp',
  },
  {
    id: 19,
    name: 'Marzo Vitorino Romanzza Plus',
    brand: 'Marzo Vitorino',
    category: 'mesa',
    price: 2400,
    description: 'Ideal para salas de reunião e ambientes operacionais. Tampos de 25mm com fita de borda de 2mm e sistemas de fixação Minifix para maior resistência.',
    features: ['Tampo 25mm com borda 2mm', 'Sistema Minifix', 'Ideal para reuniões', 'Disponível em vários tamanhos', 'Alta resistência'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/9a3cb58d-8147-412d-aa12-9adb35284d6d-bb2f45047db7c2220617367964781980-1024-1024.webp',
    badge: 'Destaque',
  },
  {
    id: 20,
    name: 'Marzo Vitorino Prima Impact',
    brand: 'Marzo Vitorino',
    category: 'mesa',
    price: 1400,
    description: 'Excelente custo-benefício e montagem robusta. Inclui opções de mesas em L e mesas de reunião de grandes dimensões para equipes numerosas.',
    features: ['Ótimo custo-benefício', 'Montagem robusta', 'Opção em L disponível', 'Mesas de reunião grandes', 'Estrutura reforçada'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/sem-titulo-5c6e93fbad266b452e17699579578462-1024-1024.webp',
  },
  {
    id: 21,
    name: 'Marzo Vitorino Impéria Premium',
    brand: 'Marzo Vitorino',
    category: 'mesa',
    price: 5200,
    description: 'Voltada para reuniões que exigem maior sofisticação. Tampos generosos para múltiplos participantes, estabilidade superior e acabamento de alto padrão.',
    features: ['Alta sofisticação', 'Tampos generosos', 'Estabilidade superior', 'Acabamento de alto padrão', 'Capacidade para até 14 pessoas'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/265bec12-95a3-4a65-8158-3651592dcd88-2df43eeed88b0c241417439566853517-1024-1024.webp',
    badge: 'Premium',
  },
  {
    id: 22,
    name: 'Marzo Vitorino Térios',
    brand: 'Marzo Vitorino',
    category: 'mesa',
    price: 4100,
    description: 'Linha executiva com design refinado, tampos espessos e pés metálicos angulados. Perfeita para diretores que buscam elegância e funcionalidade no mesmo móvel.',
    features: ['Design refinado', 'Tampos espessos', 'Pés metálicos angulados', 'Opção em L e reta', 'Passagem para cabos integrada'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/ae1e4362-c9f1-465d-9842-2c81adcb8313-114cb23855581c0eda17433691405106-1024-1024.webp',
  },

  // ─── W3 MOBILIÁRIOS DE AÇO ──────────────────────────────────────────────────
  {
    id: 23,
    name: 'W3 Armário Montável WM20405',
    brand: 'W3',
    category: 'aco',
    price: 1650,
    description: 'Armário de aço com 4 prateleiras, altura de 1980mm, largura de 900mm e profundidade de 450mm. Pintura eletrostática a pó e tratamento antiferrugem. Fechamento com chave.',
    features: ['4 prateleiras reguláveis', 'Altura 1980mm x Largura 900mm', 'Pintura eletrostática a pó', 'Tratamento antiferrugem', 'Fechamento com chave'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/img_7329-30d10fd1a15200061617288280486044-1024-1024.webp',
    badge: 'Destaque',
  },
  {
    id: 24,
    name: 'W3 Armário Escritório 160x80',
    brand: 'W3',
    category: 'aco',
    price: 980,
    description: 'Armário compacto de aço para escritório com 160cm de altura, 80cm de largura e 40cm de profundidade. Ideal para otimização de espaços menores com segurança.',
    features: ['Dimensões: 160x80x40cm', 'Pintura eletrostática', 'Tratamento antiferrugem', 'Fechamento com pitão', 'Fácil montagem'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/e518c05b-21a6-4af3-a416-4f2009feeedd-24cd0f02765a751fb317613330722376-1024-1024.webp',
  },
  {
    id: 25,
    name: 'W3 Estante W-Teca',
    brand: 'W3',
    category: 'aco',
    price: 1200,
    description: 'Estante de aço modular para bibliotecas e ambientes que exigem design diferenciado. Prateleiras com 3 dobras longitudinais para maior resistência e segurança.',
    features: ['Design diferenciado', 'Prateleiras com 3 dobras', 'Modular e adaptável', 'Suporta até 50kg por prateleira', 'Reforço em X opcional'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/94621ce2-911f-429b-83b9-4c75d0b96937-f4a1376b04693f950817175967557985-1024-1024.webp',
  },
  {
    id: 26,
    name: 'W3 Arquivo de Aço 4 Gavetas',
    brand: 'W3',
    category: 'aco',
    price: 1450,
    description: 'Arquivo de aço com 4 gavetas deslizantes para pastas suspensas. Design ergonômico com puxadores modernos e fechamento central com chave. Ideal para gestão de documentos.',
    features: ['4 gavetas para pastas suspensas', 'Fechamento central com chave', 'Puxadores modernos', 'Pintura eletrostática', 'Rodízios opcionais'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/d4241727-acfe-4c92-86b6-57490a3170dd-0535266037572bd69c17613331447258-1024-1024.webp',
    badge: 'Mais Vendido',
  },
  {
    id: 27,
    name: 'W3 Locker LSLF 10 Mini',
    brand: 'W3',
    category: 'aco',
    price: 2800,
    description: 'Locker de aço com 10 compartimentos individuais com chave. Atende às normas NR18 e NR24. Pés em polipropileno, ventilação nas portas e carenagem protetiva exclusiva.',
    features: ['10 compartimentos com chave', 'Normas NR18 e NR24', 'Pés em polipropileno', 'Ventilação nas portas', 'Carenagem protetiva'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/d138929c-7aad-4599-8763-b38568ff543b-49e7eac5719b87cf3817613331121797-1024-1024.webp',
  },
  {
    id: 28,
    name: 'W3 Estante com Gavetas Bin',
    brand: 'W3',
    category: 'aco',
    price: 1900,
    description: 'Estante de aço com 36 gavetas plásticas para organização de pequenas peças e materiais. Altura de 2000mm, suporta até 50kg por prateleira. Ideal para almoxarifados.',
    features: ['36 gavetas plásticas', 'Altura 2000mm', 'Suporta 50kg por prateleira', 'Reforço em X', 'Ideal para almoxarifado'],
    image: 'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/05ade094-011e-4157-83bd-c7b81878ef6f-273b4b32c9e2603f9e17415277084841-1024-1024.webp',
  },
];

export const chairs = products.filter(p => p.category === 'cadeira');
export const desks = products.filter(p => p.category === 'mesa');
export const steelFurniture = products.filter(p => p.category === 'aco');
